import { useState } from "react";
import { useScreenLoader } from "../components/CommonComponents/ScreenLoader";
import { FAILED } from "../constants/SiteConstants";
import service from "../services/service";

const useService = () => {
  const { startLoader, stopLoader } = useScreenLoader();

  const [isLoading, setIsLoading] = useState(false);

  /**
   *
   * @param {CallService} options
   * @returns {Promise<{ status: 'SUCCESS' | 'FAILED', result: any }> }
   */
  const callService = ({ params, loader = false }) =>
    new Promise((resolve) => {
      const processId = Date.now();
      if (loader) startLoader(processId);
      setIsLoading(true);
      service(params)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          resolve({
            status: FAILED,
            result: error,
          });
        })
        .finally(() => {
          setIsLoading(false);
          if (loader) stopLoader(processId);
        });
    });

  return { callService, isLoading };
};

export default useService;
